import React from "react";

import cx from "classnames";
import range from "lodash/range";

import NomiconIcon from "@components/NomiconIcon";

import styles from "./RatingStars.scss";

type RatingProps = {
  averageRating: number;
  showOneStar?: boolean;
  className?: string;
};

export default function RatingStars({
  averageRating,
  showOneStar = false,
  className,
}: RatingProps): JSX.Element {
  const starsCount = showOneStar ? 1 : 5;
  const filledWidth = showOneStar ? 100 : averageRating * 20;
  const ratingDisplayCount = Math.round(averageRating * 10) / 10;
  return (
    <span
      className={cx(styles.starsContainer, className)}
      aria-label={`${ratingDisplayCount} stars`}
      role="img"
    >
      <span className={styles.emptyStars}>
        {range(starsCount).map((i) => (
          <NomiconIcon key={i} icon="nomicon-star-filled" />
        ))}
      </span>
      <span className={styles.filledStars} style={{width: `${filledWidth}%`}}>
        {range(starsCount).map((i) => (
          <NomiconIcon key={i} icon="nomicon-star-filled" />
        ))}
      </span>
    </span>
  );
}
